export function stripToFactDims(
  filters: Record<string, string[]>,
  groupBy: string[],
  factDims: Set<string>,
): { filters: Record<string, string[]>; groupBy: string[] } {
  const f: Record<string, string[]> = {}
  for (const [k, v] of Object.entries(filters)) if (factDims.has(k)) f[k] = v
  return { filters: f, groupBy: groupBy.filter((d) => factDims.has(d)) }
}
